import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Typography,
  Stack,
  useTheme,
  Paper,
} from "@mui/material";
import { CheckCircle } from "@mui/icons-material";
import type { PendingJobOut } from "@providers/hop-ord-server/api";
import { tableStyles } from "./utils";

interface PendingJobsTableProps {
  pendingJobs: PendingJobOut[];
}

export const PendingJobsTable = ({ pendingJobs }: PendingJobsTableProps) => {
  const theme = useTheme();

  return (
    <TableContainer component={Paper} variant="outlined">
      <Table stickyHeader size="small" sx={tableStyles}>
        <TableHead>
          <TableRow>
            <TableCell>Stream</TableCell>
            <TableCell>Group</TableCell>
            <TableCell align="right">Pending Count</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {pendingJobs.length === 0 ? (
            <TableRow>
              <TableCell colSpan={3}>
                <Stack
                  direction="row"
                  sx={{
                    alignItems: "center",
                    gap: 1,
                    padding: 2,
                    backgroundColor: theme.palette.success.light,
                    borderRadius: 1,
                  }}
                >
                  <CheckCircle color="success" />
                  <Typography>No jobs currently in progress</Typography>
                </Stack>
              </TableCell>
            </TableRow>
          ) : (
            pendingJobs.map((job, index) => (
              <TableRow
                key={`${job.groupName}-${job.streamName}-${index}`}
                data-testid={`pending-job-${job.groupName}-${job.streamName}-${index}`}
                sx={{
                  backgroundColor:
                    job.pendingCount > 0
                      ? theme.palette.warning.light
                      : "inherit",
                }}
              >
                <TableCell>{job.streamName}</TableCell>
                <TableCell>{job.groupName}</TableCell>
                <TableCell align="right">
                  <Typography
                    sx={{
                      ...(job.pendingCount > 0
                        ? { fontWeight: "bold", color: "warning.main" }
                        : {}),
                    }}
                  >
                    {job.pendingCount}
                  </Typography>
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
